<template>
  <div class="row">
    <div class="col-12 col-lg-4" v-if="!isMobile">
      <user-info></user-info>
    </div>
    <div class="col-12 col-lg-8">
      <div class="row">
        <div class="col-12">
          <div class="account__block__title">{{ t('user.page.payout.title') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="account__block__sub-title">
            {{ t('user.page.payout.subtitle') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="account__block__sub-title-2">
            {{ t('user.page.payout.available') }}
            <b>{{ available }}</b>
          </div>
        </div>
      </div>
      <form @submit.prevent="validateForm('payout')" data-vv-scope="payout" class="block block--visible">
        <form-message :messages="getMessage(this.scope)"></form-message>
        <div class="block__content account__block__content__payout">

          <span class="h3"> Vous souhaitez toucher vos gains </span>
          <!--<br> pour un montant de (minimum 1 €)-->
          <div class="row justify-content-center pt-3 pb-3">
            <div class="col-12 col-lg-3 form-group">
              <input
                  v-model="payoutAmount"
                  v-validate="amountRules"
                  type="text"
                  :data-vv-as="t('field.payout.amount')"
                  class="form-control"
                  :class="validClasses('payout.payoutAmount')"
                  name="payoutAmount"
                  placeholder=""
                  :disabled="isLoading"
              >

              <div v-if="isInValid('payout.payoutAmount')"
                   class="invalid-feedback">
                {{ errors.first('payout.payoutAmount') }}
              </div>
            </div>
          </div>
          <div class="row justify-content-center pt3 pb-3">
            <div class="col-12 col-lg-3 form-group">
              <label for="auth__password">{{ t('auth.password') }}:</label>
              <input
                  v-model="password"
                  v-validate="'required'"
                  :class="validClasses('payout.withdrawal')"
                  name="password"
                  type="password"
                  class="form-control"
              >
              <div v-if="isInValid('payout.withdrawal')" class="invalid-feedback">
                {{ errors.first('payout.withdrawal') }}
              </div>
            </div>
          </div>
          Si votre IBAN n'est pas renseigné ci-dessous, veuillez
          <br> le saisir dans
          <router-link :to="{name: 'UserData'}" class="mesDonnes"> Mes données.</router-link>
          <br>
          <b v-if="details && details.bankaccount">
            {{ details.bankaccount }}
          </b>


          <div class="row justify-content-center pt-4 pb-3 mt-5">
            <div class="col-12 col-lg-3">
              <button class="btn btn-primary" type="submit" :disabled="isLoading">
                <loader v-if="isLoading" :size="20" :color="'#303539'"></loader>
                {{ t('user.page.payout.btn') }}
              </button>
            </div>
          </div>
        </div>
      </form>


    </div>
  </div>
</template>
<script>

import Vuex from 'vuex';
import UserInfo from './modules/info';
import store from '@/store';
import {instance, userApi} from "@/api";
import FormMessage from '@/components/parts/form-message';


export default {
  name: 'UserPayout',
  components: {
    UserInfo,
    FormMessage
  },
  beforeRouteEnter(to, from, next) {

    store.dispatch('userDataAction').then(() => {
      next();

    }).catch(function () {

      next({name: 'Auth', query: {redirect: to.fullPath}});
    })

  },
  data() {
    return {
      scope: 'payoutPost',
      payoutAmount: '',
      password: ''
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.loaderList.some(el => el === this.scope);
    },
    available() {
      if ((this.user.balance / 100) >= 1) {
        return this.formatToMoney(this.user.balance);
      } else {
        return this.formatToMoney(0);
      }

    },
    amountRules() {

      return {
        decimal: [2, '&?[,.]'],
        required: true,
        min_value_decimal: 0.01,
        max_value_decimal: this.user.balance / 100
      };

    },
    ...Vuex.mapState([
      'lang'
    ]),
    ...Vuex.mapGetters({
      user: 'getUser',
      userLogedIn: 'getUserStatus',
      details: 'getUserDetails',
    }),
  },
  methods: {

    validateForm(scope) {
      this.deleteMessage(this.scope);
      this.addLoad(this.scope);

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.doPayout();

        } else {
          this.endLoad(this.scope);
        }
      });
    },

    doPayout() {
      instance.post(userApi.withdrawal, {
        amount: parseFloat(this.payoutAmount.replace(/[,]+/g, '.').replace(/[^\d,.]+/g, '')) * 100, //convert in cents
     password: this.password
      }).then((response) => {

        if (response.data.status) {

          if (response.data.status === 'SUCCESS') {
            //SUCCESS
            //console.log(response.data.balance);

            if (typeof response.data.content.balance !== 'undefined') {
              this.$store.commit('setBalance', response.data.content.balance);
            } else {
              console.warn('ERROR: No user balance in response!');
            }

            //Clear input field
            this.payoutAmount = '';

            //Add success message
            this.addMessage({
              scope: this.scope,
              state: 'success',
              text: this.t('user.payout.success')
            });

            //Redirect to transactions
            this.$router.push({name: 'UserTransactions'});


          } else if (response.data.status === 'ERROR') {
            //ERROR

            this.restMessageHandler(response.data.status, this.scope, response.data.error, 'payout')
          }
        } else {

          //UNBELIEVABLE FAIL
          this.addMessage({
            scope: this.scope,
            state: 'danger',
            text: this.t('user.payout.error.unknown')
          });
        }

      }).catch((er) => {
        //NETWORK
        console.warn(er);
        this.addMessage({
          scope: this.scope,
          state: 'danger',
          text: this.t('user.payout.error.network')
        });
      }).then(() => {
        //Always
        this.endLoad(this.scope);
      })
    }
  }

}
</script>